<template>
<div>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickNew()"
                >
                    <v-list-item-title>New asset...</v-list-item-title>
                </v-list-item>
                <v-divider/>
                <v-list-item
                    v-on:click="onClickBulkUpload()"
                >
                    <v-list-item-title>Bulk upload...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <m-media-asset-card
        v-for="(item, index) in results"
        :key="index"
        :item="item"
        v-on:update="doUpdate"
        v-on:edit="onClickEdit"
        :select="select"
        :selected="isSelected(item)"
        v-on:select="onSelect(item,$event)"
        v-on:input="onChangeItem"
        v-on:delete="onDelete"
    /> 

    <m-edit-blobs-dialog
        ref="edit-blobs-dialog"
        v-on:ok="afterEditBlobsDialog($event)"
        :externally_visible="true"
        :allow_multiple="true"
        purpose="attachment"
        title="Add Media Asset"
        :allow_media_assets="false"
        :organization_id="$route.params.organization_id"
        dialog_hint="<b>Image Size / Format:</b>  Images should be square, no more than 1000 x 1000 pixels, in JPEG format, usign the sRGB color space and, for bottle shots, be on a solid background (white preferred)."
    />

    <div 
        style="clear: both"
    />
</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },

        content_type: {
            type: String,
            default: function() { return null; }
        },

        select: {
            type: Boolean,
            default: function() { return false; }
        },
    },
    
    data() {
        return {
            results: [],
            full_text: null,
            selected_assets: [],
        }
    },    

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            let params = {
                'organization_id': this.organization_id,
                'full_text': this.full_text,
            };

            if ( this.content_type != null )
            {
                params['created_by_content_type'] = this.content_type;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/media-assets',
            
                'params' : params,
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list media assets',
            });
        },

        onClickNew()
        {
            this.onClickEdit();
        },

        onClickEdit(asset_id)
        {
            let content_type = this.$route.params.content_type;
            let organization_id = this.$route.params.organization_id;
            
            if ( asset_id == null ) 
                asset_id = this.$rc.uuidv4();

            let name = 'media-asset-edit-one';
            if ( content_type != null )
                name = 'media-asset-edit-one-with-content-type';

            this.$router.push({
                'name': name,
                'params' : {
                    'organization_id': organization_id,
                    'content_type': content_type,
                    'asset_id': asset_id,
                }
            });
        },

        onSelect(asset, sel)
        {
            let asset_id = asset.asset_id;

            if ( sel )
            {
                if ( !this.isSelected(asset) )
                {
                    this.selected_assets.push(_.cloneDeep(asset));
                }
            }
            else
            {
                this.selected_assets = this.selected_assets.filter((el) => { return el.asset_id != asset_id; });
            }
        },


        isSelected(asset)
        {
           return this.selected_assets.find((el) => { return el.asset_id == asset.asset_id; }) != null;
        },

        getSelectedAssets()
        {
            return _.cloneDeep(this.selected_assets);
        },

        onClickBulkUpload()
        {
            this.$refs['edit-blobs-dialog'].showDialog();
        },

        afterEditBlobsDialog(blob_ids)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/integrations/outshinery/bulk-upload',
            
                'params' : {
                        'blob_ids': blob_ids,
                        'organization_id': this.$route.params.organization_id,
                        'created_by_content_type': this.content_type,
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to bulk create media assets.',
            });
        },

        onChangeItem(item)
        {
            this.$rc.rest({
                        'spinner': false,
                        'endpoint': 'PUT: /api/v1/media-assets',
                    
                        'params' : item,
                    
                        'on_success': (data) => {
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to save media asset',
                    });
        },

        onDelete(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'DELETE: /api/v1/media-assets',
            
                'params' : {
                        'asset_id': item.asset_id,
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to delete media asset',
            });
        }
    },

    computed: {
    },
}
</script>

<style lang="scss" scoped>

</style>